import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=078c6f07&scoped=true"
import script from "./CommentThread.vue?vue&type=script&lang=js"
export * from "./CommentThread.vue?vue&type=script&lang=js"
import style0 from "./CommentThread.vue?vue&type=style&index=0&id=078c6f07&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c6f07",
  null
  
)

export default component.exports